import { render } from "./Header.vue?vue&type=template&id=6f3b3072"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6f3b3072&lang=less"

import exportComponent from "D:\\work\\code\\jingcisi\\wx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__